// Greenhold SPA API client placeholder. Story 1.8 ships the helper that
// captures the backend's X-Request-ID and tags the next outbound Sentry
// events with it. Story 1.11 will fill in the full fetch wrapper (auth
// headers, error mapping, etc.); this file exists now so its imports are
// stable for future stories to extend.

import * as Sentry from "@sentry/react";

/**
 * Read the X-Request-ID from a backend response and tag the active Sentry
 * scope with it. Future call sites (auth, wallet, marketplace, etc.) will
 * call this on every fetch response so a frontend error gets pinned to the
 * exact backend request that fed it.
 */
export function attachRequestIdToScope(response: Response): void {
  const requestId = response.headers.get("x-request-id");
  if (!requestId) return;
  Sentry.getCurrentScope().setTag("correlation_id", requestId);
}
